import { CircularProgress } from "@mui/material";
import React from "react";

const CenterLoader = () => {
  return (
    <div className="page-center">
      <CircularProgress />
    </div>
  );
};

export default CenterLoader;
